const getInitialState = () => ({ view: 'country' });
import { trackEvent } from 'utils/analytics';

export const actions = {
	switch: (state, id) => {
		trackEvent('Map view', 'Update', `By ${id}`);
		return { ...state, view: id };
	}
};

export default {
	getInitialState,
	actions
};



// WEBPACK FOOTER //
// ./state/view.js